import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-my-bet-list',
  templateUrl: './my-bet-list.component.html',
  styleUrls: ['./my-bet-list.component.css']
})
export class MyBetListComponent implements OnInit {

  public api = api;
  public env = environment;
  public data: any;
  public user: any;
  @Input() isModal: boolean = false;
  constructor(public service: WebserviceService,
    public _common: CommonService) { }

  ngOnInit(): void {
    this.user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';
    this.getData('');
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData(url: any) {
    let apiurl = url == '' ? `${this.env.baseUrl + this.api.orderList}` : url;
    this.getServices().Get(`${apiurl}`).subscribe(
      (res) => {
        if (res.status == true) {
          res.data.orders.data = this._common.UTC_to_Local_timeZone(res.data.orders.data);
          this.data = res.data;
        }
      },
      (err) => {
        console.log(err);
      });
  }

  changePage(e: any) {
    if (e.label != this.data.transactions.current_page) {
      this.getData(e.url);
    }
  }


  trackByIndex(index: number, obj: any): any {
    return index;
  }
}
